import CopyrightFooter from './CopyrightFooter';
import FooterContent from './FooterContent';

const index = ({ footerStyle = '' }) => {
  return (
    <footer className={`main-footer ${footerStyle}`}>
      <div className='auto-container'>
        {/* <!--Widgets Section--> */}
        <div className='widgets-section' data-aos='fade-up'>
          <div className='row'>
          
            
              {/* <div className='footer-column about-widget'>
                <div className='logo'>
                  <a href='#'>
                    <img src='images/origins-logo.png' alt='brand' width={100} height={50} />
                  </a>
                </div>
                <p className='phone-num'>
                  <span>Call us </span>
                  <a href='thebeehost@support.com'>011 454 0196 // 011 454 0212</a>
                </p>

                <p className='address'>
                  33 Linksfield Road, Dunvegan, Edenvale
                  <br /> Johannesburg,South Africa. <br />
                  <a href='mailto:support@superio.com' className='email'>
                    recruit@myorigins.co.za
                  </a>
                </p>
              </div>
            </div> */}
            {/* End footer left widget */}

            <div className='big-column col-xl-8 col-lg-9 col-md-12'>
              <div className='row'>
                <FooterContent />
              </div>              
            </div>
            {/* End col-xl-8 */}            
          </div>
        </div>
      </div>
      {/* End auto-container */}
     
      <CopyrightFooter />
     
      {/* <!--Bottom--> */}
    </footer>
    //   {/* <!-- End Main Footer --> */}
  );
};

export default index;
